module.exports = __webpack_public_path__ + "img/scholars.a6eaa5fb.svg";